import { render, staticRenderFns } from "./LocationWindow.vue?vue&type=template&id=0356f9dc&"
import script from "./LocationWindow.vue?vue&type=script&lang=js&"
export * from "./LocationWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports